import { reduxType } from "../../interfaces/reducerType"
const defaultState: Boolean = true
function reducer(state = defaultState, { type, payload }: reduxType) {
    switch (type) {
        case "setReginalStateChanger":
            return payload
        default:
            return state;
    }
}
export default reducer;